
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.91 7.599a2.863 2.863 0 014.266 0l1.226 1.369c.58.647 1.423.997 2.291.949l1.834-.102a2.863 2.863 0 013.017 3.017l-.101 1.834a2.863 2.863 0 00.949 2.292l1.368 1.225a2.863 2.863 0 010 4.267l-1.368 1.225a2.863 2.863 0 00-.95 2.291l.102 1.834a2.863 2.863 0 01-3.017 3.017l-1.834-.101a2.863 2.863 0 00-2.291.949l-1.226 1.368a2.863 2.863 0 01-4.266 0l-1.225-1.368a2.863 2.863 0 00-2.292-.95l-1.834.102A2.863 2.863 0 019.542 27.8l.102-1.834a2.863 2.863 0 00-.95-2.291l-1.368-1.226a2.863 2.863 0 010-4.266l1.368-1.225c.648-.58.998-1.423.95-2.292l-.102-1.834a2.863 2.863 0 013.017-3.017l1.834.102a2.863 2.863 0 002.292-.95L17.91 7.6z","stroke":"#1D1D1D","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M25.564 16.29l-7.419 7.42-3.71-3.71","stroke":"#1D1D1D","stroke-width":"1.5","stroke-linecap":"square","stroke-linejoin":"round"}})])
          )
        }
      }
    